<template>
  <span class="">
      <div v-if="busy" class="busy-container"><BusySpinner /></div>
      <div v-else class="container">
        <div class="sub-service">
          <p class="bold">
            🗞️Website News List
          </p>
          <p>
            Data is stored in Airtable (<a href="https://airtable.com/appoRbWtM4wHkP4Qr/tblFF7XlGrCKF9Vu1/viwlUS6MsQIcQOqTU?blocks=hide" target="_blank">link</a>)
          </p>
          <p>
            Documentation is in Notion (<a href="https://www.notion.so/alightcreative/Website-Landing-Page-news-list-CMS-88ba354463af4b078ed0787cbf448ffb" target="_blank">link</a>)
          </p>
          <form class="form">
            <a href="https://alight-creative-staging.web.app/" target="_blank">View on Staging.</a>
            <a href="https://alightcreative.com/" target="_blank">View on Production.</a>
          </form>
          <form class="form">
            <button type="button" @click="fetchContent('staging')">Deploy to Staging.</button>
            <button type="button" @click="fetchContent('production')">Deploy to Production.</button>
          </form>
          <div v-if="status" class="summary">
            <div class="status">
                {{ status }}
            </div>
            <div class="">
                {{ data }}
            </div>
          </div>
          <div v-if="error" class="summary">
             {{ error }}
          </div>
        </div>
      </div>

  </span>
</template>

<script>
import BusySpinner from '@/components/BusySpinner.vue'
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  name: "WebSiteNews",
  components: { BusySpinner },
  data: ()=>({
    busy: false,
    data: null,
    status: '',
    error: null
  }),
  computed: {
  },
  methods: {
    fetchContent(type) {
      const curl = window.location.href
      if (curl.includes("localhost") || curl.includes("0.0.0.0")) {
          firebase.functions().useFunctionsEmulator("http://0.0.0.0:5001")
      }
      const endpoint = firebase.functions().httpsCallable('fetchWebSiteNews')
      this.busy = true
      endpoint({type}).then((res) => {
        console.log(res.data)
        this.busy = false
        this.status = type + " : " + res.data.status
        this.error = null
      }).catch((error) => {
        this.busy = false
        this.error = error
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
.container {
  display: flex;
}
.busy-container {
  display: flex;
  justify-content: center;
}
.sub-service {
  border: 0.1em black solid;
  padding: 10px;
  border-radius: 5px;
}
.status {
  font-weight: bold;
}
.form {
  display: flex;
  justify-content: space-between;
  button {
    min-height: 80px;
    font-size: 12pt;
    width: 110px;
    cursor: pointer;
  } 
  a {
    width: 110px;
    text-align: center;
    margin-bottom: 10px;
  }
}
.summary {
  margin-top: 20px;
  padding-top: 5px;
  border-top: 1px black solid;
}
</style>
